import Head from 'next/head';
import type { ReactElement } from 'react';

import { ISeoProps } from '@/shared/components/molecules/Seo/ISeo';

// import { isDevelopment } from '@/shared/constant/env';
import aydiLogo from '~/logo.png';

const defaultMeta = {
  title: 'Aydi',
  siteName: 'Aydi',
  description: 'aydi',
  /** Without additional '/' on the end */
  url: 'https://eye.aydi.com',
  type: 'website',
  // robots: !isDevelopment ? 'follow, index' : 'nofollow, noindex',
  robots: 'none',

  /** No need to be filled, will be populated with openGraph function */
  image: aydiLogo,
};

export default function Seo({ seoData }: ISeoProps): ReactElement {
  const meta = {
    ...defaultMeta,
    ...seoData,
  };
  meta['title'] = seoData?.templateTitle
    ? `${seoData.templateTitle} | ${meta.siteName}`
    : meta.title;

  return (
    <Head>
      <title>{meta.title}</title>
      <meta name='robots' content={meta.robots} />
      <meta name='title' content={meta.title} />
    </Head>
  );
}
